import axiosInstance from './axiosInstance'

export const getProjectShipToById = (id) => {
  return axiosInstance.get(`/project-ship-to/${id}`)
}

export const getProjectShipToByProjectId = (projectId) => {
  return axiosInstance.get(`/project-ship-to/?projectId=${projectId}`)
}

// export const getProjectShipTos = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
//   return axiosInstance.get(`/project-ship-to?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
// }

export const createProjectShipTo = (data) => {
  return axiosInstance.post('/project-ship-to', data)
}

export const upsertProjectShipTo = (id, data) => {
  return axiosInstance.put(`/project-ship-to/${id}`, data)
}

export const deleteProjectShipTo = (id) => {
  return axiosInstance.delete(`/project-ship-to/${id}`)
}
